module.exports = __webpack_public_path__ + "components/MapControl/svg/Hostel.svg?bfc20b42";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Hostel.svg
// module id = 2065
// module chunks = 0